module.exports = __webpack_public_path__ + "images/category_lp/camera/Canon-EOS-5D-Mark-IV_f6ac5deb616539aa1940d415a4339e73.png";